

<div class="col-md-12">
  <div class="form-group">
    <div class="col-sm-12 table-responsive">
      <div class="form-row" *ngIf="selected">


        <div class="form-group col">


          <span style="font-size: 20px;"><strong>Choose Connector</strong></span>
          <br />
          <div class="dropdown-divider mt-2"></div>
          <div *ngFor="let Connector of ConnectorSelected | pairs" class="col-md-12">
            <div class="d-flex mt-1">
              <div class="flex-fill pl-3 pr-3 col-md-6">
                <div class="text-left divider_card_title"><a class="enable-link" href="javascript:void()" (click)="AddAction(Connector[0].uId, content)">{{Connector[0].connectorName}}</a></div>
                <div class=" value_unit mt-1"><img src="{{ url + Connector[0].logo}}" class="img-fluid" width="100" /></div>
                <!--<h3 class="text-right mt-2"> </h3>-->
              </div>
              <div class="flex-fill pl-3 pr-3 col-md-6" *ngIf="Connector[1]?.connectorName">
                <div class="text-left divider_card_title"><a class="enable-link" href="javascript:void()" (click)="AddAction(Connector[1].uId, content)">{{Connector[1].connectorName}}</a></div>
                <div class=" value_unit mt-1"><img src="{{ url + Connector[1].logo}}" class="img-fluid" width="100" /></div>

              </div>


            </div>

            <div class="dropdown-divider mt-2"></div>
          </div>
        </div>
      </div>

      <div class="form-row" *ngIf="!selected">
        <div class="form-group col">
          <span style="font-size: 20px;"><strong>Choose Connector</strong></span>
          <br />
          <table class="table " width="100%">

            <tbody>
              <tr *ngFor="let Connector of Connectors;let j=index">
                <div *ngIf="Connector.uId == Connector1 ; then ifblock1"></div>

                <ng-template #ifblock1>
                  <td><img src="{{ url +  Connector.logo}}" class="img-fluid" style="width: 14%;margin-right:5%" />  {{Connector.connectorName}}</td>

                  <td>  <a class="enable-link" href="javascript:void()" (click)="ChangeAction()">Change</a> </td>
                  <!--<td style="width: 20%">  <a class="enable-link" href="javascript:void()" (click)="open(content)">Configure</a> </td>-->
                  <td style="width: 20%">  <a class="enable-link" href="javascript:void()" (click)="AddAction(Connector.uId , content)">Configure</a> </td>
                </ng-template>
              </tr>
            </tbody>
          </table>
        </div>

      </div>

    </div>
  </div>
</div>


<form [formGroup]="form2" (ngSubmit)="onSubmit2()" *ngIf="ActionSelect">
  <div class="col-sm-12 table-responsive">
    <div class="form-row">
      <div class="form-group col">
        <span style="font-size: 20px;">
          <strong>
            Choose Action 
          </strong>
        </span>
        <br />
        <select class="form-control" (change)="selectAction($event.target.value)" formControlName="eventID">
          <option value="0">Choose an event</option>
          <option *ngFor="let summary of actionEvents" value={{summary.id}}>
            {{summary.name}} ( {{summary.des}} )
          </option>
        </select>
      </div>
    </div>

  </div>
</form>


<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title"> {{ cname }} Authentication</h4>
    <button type="button" class="btn btn-outline-dark" (click)="modal.close('Save click')"><span aria-hidden="true">&times;</span></button>
  </div>
  <form [formGroup]="form" (ngSubmit)=" form.valid && onSubmit()">
    <div class="modal-body">
      <!-- <a *ngIf="!popch && cname == 'Slack'" (click)="SaveDetail()" href="https://slack.com/oauth/v2/authorize?client_id={{ client_id }}&scope=channels:history,chat:write,incoming-webhook,users:read,users:read.email,calls:read&redirect_uri={{ redirect_uri }}&user_scope="><img alt="Add to Slack" height="40" width="139" src="https://platform.slack-edge.com/img/add_to_slack.png" srcSet="https://platform.slack-edge.com/img/add_to_slack.png 1x, https://platform.slack-edge.com/img/add_to_slack@2x.png 2x" /></a> -->
      <a *ngIf="!popch && cname == 'Slack'" (click)="SaveDetail()" href="https://slack.com/oauth/v2/authorize?client_id={{ client_id }}&scope=chat:write,incoming-webhook,users:read,users:read.email&redirect_uri={{ redirect_uri }}&user_scope="><img alt="Add to Slack" height="40" width="139" src="https://platform.slack-edge.com/img/add_to_slack.png" srcSet="https://platform.slack-edge.com/img/add_to_slack.png 1x, https://platform.slack-edge.com/img/add_to_slack@2x.png 2x" /></a>

      <!--<a *ngIf="!popch && cname == 'Microsoft Teams'" (click)="SaveDetail()" href="https://login.microsoftonline.com/common/oauth2/v2.0/authorize?response_type=code&client_id={{ client_id }}&scope=https%3A%2F%2Fgraph.microsoft.com%2F.default%20offline_access&redirect_uri={{ TeamsReturnURL }}"><img alt="Add to Microsoft Teams" height="50" width="200" src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSsW1iGSxzWWb0GONm-tkw4UoKbAErCjFuxQu7YbmOdPcvzw45mYkG8QmVyS2aLne84iA&usqp=CAU" srcSet="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSsTFgGuBxrEffTF7ffCb9EGCGx74rzFgPFMjUC6sJwLZ-A9Kfh1rtEFL3VpQ34ucwW0g&usqp=CAU, https://platform.slack-edge.com/img/add_to_slack@2x.png 2x" /></a>-->
      <a *ngIf="!popch && cname == 'Microsoft Teams'" (click)="SaveDetail()" href="https://login.microsoftonline.com/common/oauth2/v2.0/authorize?response_type=code&client_id={{ client_id }}&scope=https%3A%2F%2Fgraph.microsoft.com%2F.default%20offline_access&redirect_uri={{ TeamsReturnURL }}&prompt=select_account"><img alt="Add to Microsoft Teams" height="50" width="200" src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSsW1iGSxzWWb0GONm-tkw4UoKbAErCjFuxQu7YbmOdPcvzw45mYkG8QmVyS2aLne84iA&usqp=CAU" srcSet="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSsTFgGuBxrEffTF7ffCb9EGCGx74rzFgPFMjUC6sJwLZ-A9Kfh1rtEFL3VpQ34ucwW0g&usqp=CAU, https://platform.slack-edge.com/img/add_to_slack@2x.png 2x" /></a>

      <span style="color:green"> {{ showmessage }}</span>
      <div class="col-md-12" style="background-color:#fff;margin-top:10px;" *ngIf="popch">
        <div class="form-row">

          <div class="form-group col">
            <div style="    display: grid;    grid-template-columns: 200px auto;    gap: 15px;">
              <div style="position: relative;">
                <span class="label label-default"> {{ label_nm }}</span>
              </div>
              <div style="position: relative;">
                <input type="text" name="Userkey" id="userkey" class="form-control" placeholder="Enter {{ label_nm }}" formControlName="autoUserID" [ngClass]="{ 'is-invalid': form.get('autoUserID').touched && form.get('autoUserID').invalid  }" />
                <div class="invalid-feedback">
                  Key required
                </div>
                <span style="color:red"> {{ showWrongTokenMessage }}</span>
              </div>
            </div>
          </div>

        </div>


      </div>


    </div>
    <div class="modal-footer">
      <div class="col-md-12" style="background-color:#fff;margin-top:10px;">


        <div class="form-row">
          <div class="form-group col">

            <table width="100%">
              <tr>
                <td style="float:left">
                  <button class="btn btn-primary" [disabled]="!form.valid" *ngIf="popch" >
                    <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                    Authenticate
                  </button>
                </td>
                <td style="float:right">

                  <!--<button type="button" class="btn btn-outline-dark" (click)="modal.close('Save click')">Close</button>-->
                </td>
              </tr>
            </table>

          </div>
        </div>
      </div>


    </div>
  </form>

  
</ng-template>
<!--<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title"> {{ cname }} Authentication</h4>

    <a><i class="fa fa-close" data-dismiss="modal" #closeBtn></i></a>
  </div>
  <div class="modal-body">
    {{ AuthType }}
    <div class="col-md-12" style="background-color:#fff;margin-top:10px;" *ngIf="popch">
      <api-authenticate [item]="cID" [flg]="flg" (someEvent)="closeModal($event)"></api-authenticate>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="modal.close('Save click')">Close</button>
  </div>
</ng-template>-->
